export const ERROR_2FA_CANCELED = '2fa_canceled';
